import { ErrorMutation } from "../types";

export default {
  [ErrorMutation.SET_DIALOG_CONTROLS](state: any, payload: any) {
    state.dialogControls = payload;
  },
};
